import { action } from 'typesafe-actions';
import { LoadingActionTypes as types } from './types';
/* ********************************* APP ACTIONS ********************************* */

export const loadingStart = (): any => action(types.LOADING_START, {});

export const loadingFinish = (): any => action(types.LOADING_FINISH, {});

export const actionConfirmed = (text, type): any => action(types.ACTION_CONFIRMED, {
  text,
  type,
});

export default null;
